//用于打开页面并获取页面按钮权限
import store from '../vuex/store';
import routes from '../routes';
import VueRouter from 'vue-router';
import { router } from '../main.js'
import { privilegescheck } from "../api/api";
const openpage = function (link,query) {
  let menulist = store.state.menulist;
  var id = null;
  if (menulist && menulist.length > 0) {
    menulist.forEach(element => {
      if (element.link == link) {
        id = element.id
        return false
      }

      if (element.submenu && element.submenu.length > 0) {
        element.submenu.forEach(item => {
          if (item.link == link) {
            id = item.id;
            return false
          }
          if (item.submenu && item.submenu.length > 0) {
            item.submenu.forEach(value => {
              if (value.link == link) {
                id = value.id;
                return false
              }
            })
          }
        })
      }
    });

  }
  privilegescheck({
    id: id
  }).then(res => {
    var data = res.data;
    if (data.code == 1) {
      var Data = data.data;
      var state = {
        privilegescheck: Data,
        activiId: id
      };

      store.commit("SIGN_Login", state);
      router.push({path: link, query: query});
      
    }
  })

}
export default openpage



// WEBPACK FOOTER //
// ./src/constant/openpage.js